import { apiClient } from "./client";
import type { ExternalSlipView } from "../types/externalSlip";

export const externalSlipQueryKeys = {
  all: ["external-slips"] as const,
  forAppointment: (appointmentId: string) =>
    ["external-slips", "appointment", appointmentId] as const,
};

/** Phiếu khám ngoài theo lịch hẹn — cho nhân viên, quyền `appointment.read` (máy chủ ghi nhật ký PHI). */
export const externalSlipsApi = {
  forAppointment(appointmentId: string): Promise<ExternalSlipView[]> {
    return apiClient
      .get<ExternalSlipView[]>("/v1/external-slips", { params: { appointmentId } })
      .then((r) => r.data);
  },
};
